import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import { api } from "../lib/api";
import { DiplomaCard } from "../components/DiplomaCard";
import { Logo } from "../components/Logo";
import { Download, Loader2 } from "lucide-react";

export default function RecognitionPublic() {
  const { id } = useParams();
  const [rec, setRec] = useState(null);
  const [loading, setLoading] = useState(true);
  const cardRef = useRef(null);

  useEffect(() => {
    api.get(`/recognitions/${id}`).then((r) => setRec(r.data)).catch(() => setRec(false)).finally(() => setLoading(false));
  }, [id]);

  const download = async () => {
    try { if (document.fonts?.ready) await document.fonts.ready; } catch {}
    const canvas = await html2canvas(cardRef.current, { scale: 2, backgroundColor: "#ffffff", useCORS: true, logging: false });
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `diploma-${(rec?.patient_name || "oci").replace(/\s+/g, "_")}.png`;
    a.click();
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center py-10 px-4">
      <div className="mb-6"><Logo size={40} /></div>
      {loading ? (
        <Loader2 className="animate-spin text-brand-terracotta mt-10" />
      ) : !rec ? (
        <p className="text-brand-ink/70 mt-10">Este reconocimiento no está disponible.</p>
      ) : (
        <>
          <div className="overflow-auto max-w-full flex justify-center">
            <div style={{ transform: "scale(0.9)", transformOrigin: "top center" }}>
              <DiplomaCard ref={cardRef} type={rec.type} patientName={rec.patient_name}
                signatureUrl={rec.doctor_signature} qrUrl={window.location.href} />
            </div>
          </div>
          <button data-testid="recognition-download" onClick={download}
            className="mt-6 flex items-center gap-2 bg-brand-terracotta hover:opacity-90 text-white font-bold py-3 px-6 rounded-2xl transition-all">
            <Download size={18} /> Descargar diploma
          </button>
          <p className="text-xs text-muted-foreground mt-4 text-center max-w-sm">Un reconocimiento de tu médico con ClinPed. ¡Felicidades!</p>
        </>
      )}
    </div>
  );
}
